import React,{useState,useEffect} from 'react'
import './Video.css'
import Pagination from '@mui/lab/Pagination'
import VideoPlayer from 'react-video-js-player';
import video from '../../../assets/Video/video1.mp4'
import axios from 'axios';

function Video() {
  const vidsrc=video;
  const [videos,setVideos]=useState([])
  const [page,setPage]=useState(1)
  return (
    <div className='Videos'>
     
     <div className="Videos__wrapper">
       <div className="videobox">
       <VideoPlayer
       src={vidsrc}
       
       />
       
       <div className='video__title'><span>Bu yilgi bitiruvchilar tadbiridan video lavhalar</span> </div>
       </div>
     </div>
     <div className='pagination'>
       
       <Pagination count={23} 
       color={"primary"}
       defaultPage={page}
       siblingCount={0}
       boundaryCount={2}
       onChange={(event,value)=>setPage(value)}
       size="large"
       />
     
       </div>
    </div>
  )
}

export default Video